import { scrollAnimation } from './function/scroll-animation.js';
const tile = require('./function/tile.js');
const slick = require('/assets/js/slick/slick.js');
import '/assets/js/common.js';
import '/assets/js/slick/slick.css';
import '/assets/css/_common.scss';
import '/assets/css/sales.scss';


// ===========================================
// 業種から選ぶスライダー
// ===========================================
$(function () {
  // スライドショーを最適化して実行する関数
  function slideSet(
    slide,
    slideNav,
    arrow,
    dotCurrent,
    slideNum,
    dotMaxNum,
    dotMax
  ) {
    slideNum = Math.round( slide.width() / 300 );

    if( slideNum < slide.find('.industrySlide__item').length ) {
      slide.removeClass('unslide');
      slideNav.removeClass('unslide');
      slide.slick({
        appendArrows: arrow,
        appendDots: dotCurrent,
        slidesToShow: slideNum,
        dots: true,
        infinite: false,
      });

      dotMaxNum = Number( dotCurrent.find('.slick-dots li').length );
      dotMax.html( dotMaxNum );
    } else {
      slide.addClass('unslide');
      slideNav.addClass('unslide');
    }
  }

  $('.industrySlideWrapper').each(function(){
    const slide = $(this).find('.industrySlide'),
          slideNav = $(this).prev(),
          arrow = slideNav.find('.industryArrow'),
          dotCurrent = slideNav.find('.industryDotCurrent'),
          dotMax = dotCurrent.next(),
          catBtn = slideNav.prev().find('.industryNav__btn');
    let slideNum,
        dotMaxNum,
        beforeWidth = $(window).width(),
        currentCat;

    // スライドショーを最適化して実行
    slideSet(
      slide,
      slideNav,
      arrow,
      dotCurrent,
      slideNum,
      dotMaxNum,
      dotMax
    );

    // 画面をリサイズしたときのスライドショーの処理
    $(window).on('resize', function(){
      if( $(window).width() !== beforeWidth ) {
        // いったんスライドショーを解除
        if( ! slide.hasClass('unslide') ) {
          slide.slick('unslick');
        }

        // スライドショーを最適化して実行
        slideSet(
          slide,
          slideNav,
          arrow,
          dotCurrent,
          slideNum,
          dotMaxNum,
          dotMax
        );
      }

      beforeWidth = $(window).width();
    });

    // カテゴリーを選択したときのインタラクション
    catBtn.on('click', function(){
      currentCat = $(this).attr('data-cat');

      // カレントの処理
      catBtn.each(function(){
        const _this = $(this);

        if( _this.hasClass('current') ) {
          _this.removeClass('current');
        }
      });
      $(this).addClass('current');

      // いったんスライドショーを解除
      if( ! slide.hasClass('unslide') ) {
        slide.slick('unslick');
      }

      // スライドショーの中のhtmlを、選択されたカテゴリーのスライドに書き換え
      slide.html('');
      slideItemHtmls.forEach(function ( slideItemHtml ) {
        if( slideItemHtml.cat === currentCat ) {
          slide.append( slideItemHtml.html );
        }
      });

      // スライドショーを再度最適化して実行
      slideSet(
        slide,
        slideNav,
        arrow,
        dotCurrent,
        slideNum,
        dotMaxNum,
        dotMax
      );
    });
  });
});